import {useContext} from "react";
import PusherContext from "../context/PusherContext";
import { PusherContextInterface } from "../services/exports/Interfaces";


export default function usePusher(): PusherContextInterface {
    return useContext(PusherContext);
}